import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
        width: 200,
      borderBottom: 'none',
    },
    centerITem: {
      alignContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    },
    textAddressField: {  
        marginLeft: '3%',
        marginRight: '10%',     
        width: '90%',      
    },
    FulltextField: {
        marginLeft: '3%',
        marginRight: '10%',     
        width: '90%', 
    },
    dense: {
      marginTop: 19,
    },
    menu: {
      width: 200,
    },
    root: {
        marginBottom: "1%",
        marginTop: "1%",
    },
    title: {
        textAlign: "left",
    },
    Popover_text: {
        padding: theme.spacing(2),
      },
    button: {
        margin: theme.spacing(1),
    },
    yesbutton: {
      margin: theme.spacing(1),
      marginLeft: "39%",
    },
    nextbutton: {
      margin: theme.spacing(1),
      color: 'white',
    },
    nobutton: {
        margin: theme.spacing(1),
        color: 'red',
        boxShadow: 'red',
        borderColor: 'red',
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      
    }, body: {
      paddingLeft: '13%',
      paddingRight: '13%',
      padding: theme.spacing(2, 2),
    },
    container: {
      paddingTop: '1%',
      paddingBottom: '5%',
    },
    linkstyle: {
      component:"button"
    },
    stepper: {
      padding: '1%',
      backgroundColor : '#e3f2fd',
      [theme.breakpoints.down('973')]: {
        display: 'inline',
      },
    }, 
    bottompart: {
      textAlign: "center",
    },
    arrow: {
      fontSize: "40px",
      position: "relative",
      bottom: "-15px",
    },
  }));

  export default useStyles;